import React, { useState } from 'react';
import { supabase } from '../../utils/supabaseClient';
import { useTranslation } from '../../hooks/useTranslation';

const FeedbackButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [isSending, setIsSending] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSending(true);

    try {
      const { error } = await supabase
        .from('feedback')
        .insert([{ message, email: email || null }]);

      if (error) throw error;

      setShowSuccess(true);
      setMessage('');
      setEmail('');
      setTimeout(() => {
        setIsOpen(false);
        setShowSuccess(false);
      }, 3000);
    } catch (error) {
      console.error('Error submitting feedback:', error);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {!isOpen ? (
        <button
          onClick={() => setIsOpen(true)}
          className="bg-[var(--brand-primary)] hover:bg-[var(--brand-hover)] text-[var(--text-button)] px-4 py-2 rounded-full shadow-lg transition-all duration-200 flex items-center space-x-2"
        >
          <span>💭</span>
          <span>{t('feedback.button')}</span>
        </button>
      ) : (
        <div className="bg-white p-4 rounded-lg shadow-xl w-80">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold">{t('feedback.title')}</h3>
            <button
              onClick={() => setIsOpen(false)}
              className="text-[var(--text-secondary)] hover:text-[var(--text-primary)]"
            >
              ✕
            </button>
          </div>
          
          {showSuccess ? (
            <div className="text-[var(--success)] text-center py-4">
              {t('feedback.success')}
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder={t('feedback.placeholder.message')}
                  className="w-full p-2 border rounded-md resize-none h-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div className="mb-4">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t('feedback.placeholder.email')}
                  className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <button
                type="submit"
                disabled={isSending}
                className="w-full bg-[var(--brand-primary)] hover:bg-[var(--brand-hover)] text-[var(--text-button)] py-2 rounded-md transition-colors duration-200 disabled:opacity-50"
              >
                {isSending ? t('feedback.sending') : t('feedback.submit')}
              </button>
            </form>
          )}
        </div>
      )}
    </div>
  );
};

export default FeedbackButton;